import { motion, useScroll } from "framer-motion";

export default function ProgressBar() {
  const { scrollYProgress } = useScroll({ layoutEffect: false });
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed inset-x-0 top-0 z-[70] h-[3px] origin-left bg-gradient-to-r from-crimson via-neon to-ember"
      style={{ scaleX: scrollYProgress }}
    />
  );
}
